<template>
    <div :style="{'direction': $vs.rtl ? 'rtl' : 'ltr'}">
      <feather-icon icon="Edit3Icon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="editRecord" />
      <feather-icon icon="Trash2Icon" svgClasses="h-5 w-5 hover:text-danger cursor-pointer" @click="confirmDeleteRecord" />
    </div>
</template>

<script>
    export default {
        name: 'CellRendererActions',
        methods: {
          editRecord() {
            this.$router.push("/application/formateur/user-edit/" + this.params.data.id).catch(() => {})

            /*
              Below line will be for actual product
              Currently it's commented due to demo purpose - Above url is for demo purpose

              this.$router.push("/apps/user/user-edit/" + this.params.data.id).catch(() => {})
            */
          },
          confirmDeleteRecord() {
            this.$vs.dialog({
              type: 'confirm',
              color: 'danger',
              title: `Confirmation de la suppression`,
              text: `Vous êtes sur le point de supprimer "${this.params.data.nom} ${this.params.data.prenom}"`,
              accept: this.deleteRecord,
              acceptText: "supprimer"
            })
          },
          deleteRecord() {
            /* Below two lines are just for demo purpose */
            //this.showDeleteSuccess()
            this.$store.dispatch("formateur/removeRecord", this.params.data.id).then(()   => { this.showDeleteSuccess() }).catch(err => { console.error(err);this.showDeleteeror()       })
            
            
            /* UnComment below lines for enabling true flow if deleting user */
            // this.$store.dispatch("userManagement/removeRecord", this.params.data.id)
            //   .then(()   => { this.showDeleteSuccess() })
            //   .catch(err => { console.error(err)       })
          },
          showDeleteeror() {
            this.$vs.notify({
              color: 'danger',
              title: 'Formateur pas supprimé',
              text: 'Formateur sélectionné pas supprimé'
            })
            
          },
          showDeleteSuccess() {
            this.$vs.notify({
              color: 'success',
              title: 'Formateur supprimé',
              text: 'Formateur sélectionné a été supprimé avec succès'
            })
            
          }
        }
    }
</script>
